export const getWidgetTypeFromId = (widgetId: string): string => {
  // Check allocation-table BEFORE general allocation to avoid mismatching
  if (widgetId.includes('allocation-table')) return 'PlainTableWidget';
  // Check sector-allocation BEFORE general allocation to avoid mismatching
  if (widgetId.includes('sector-allocation')) return 'SectorAllocationWidget';
  if (widgetId.includes('allocation')) return 'AllocationWidget';
  if (widgetId.includes('proposed-portfolio')) return 'ProposedPortfolioWidget';
  if (widgetId.includes('ai-recommendations')) return 'AIRecommendationsWidget';
  if (widgetId.includes('projected-risk-metrics'))
    return 'ProjectedRiskMetricsWidget';
  if (widgetId.includes('expected-impact')) return 'ExpectedImpactWidget';
  if (widgetId.includes('risk-alerts')) return 'RiskAlertsWidget';
  if (widgetId.includes('market-analysis')) return 'MarketAnalysisWidget';
  if (widgetId.includes('news-impact-analysis'))
    return 'NewsImpactAnalysisWidget';
  if (widgetId.includes('ems-blotter')) return 'EMSBlotterWidget';
  if (widgetId.includes('historical-returns')) return 'HistoricalReturnsWidget';
  if (widgetId.includes('forward-returns')) return 'ForwardReturnsWidget';
  if (widgetId.includes('recommendation-report'))
    return 'RecommendationReportWidget';
  if (widgetId.includes('correlation-cluster'))
    return 'CorrelationClusterWidget';
  if (widgetId.includes('asset-breakdown')) return 'AssetBreakdownWidget';
  return 'UnknownWidget';
};
